import { render } from "./VBtn.vue?vue&type=template&id=fceb4e58"
import script from "./VBtn.vue?vue&type=script&lang=js"
export * from "./VBtn.vue?vue&type=script&lang=js"

import "./VBtn.vue?vue&type=style&index=0&id=fceb4e58&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__